import React, { Component } from 'react';

import './style.css';

export default class NumberSelector extends Component {
  componentWillUnmount() {
    this.props.onChange(null);
  }

  onChange() {
    let that = this;
    for (let i = this.props.start; i <= this.props.end; i++) {
      if (that.refs[`${this.props.name}${i}`].checked) {
        this.props.onChange(i);
      }
    }
  }

  render() {
    const {
      name,
      label,
      classes,
      title
    } = this.props;

    const styleList = classes ? classes.join(' ') : '';

    let numbers = [];
    for (let i = this.props.start; i <= this.props.end; i++) {
      numbers.push(
        <div className={`number-selector__container ${i === this.props.end ? 'number-selector__container_last' : null}`}>
          <input
            id={i}
            hidden={true}
            type='radio'
            name={name}
            defaultChecked={this.props.defaultValue == i ? true : this.props.checked}
            onClick={() => {this.onChange()}}
            className={'number-selector__input'}
            ref={`${name}${i}`}
          />
          <label
            className={'number-selector__label'}
            htmlFor={i}
          >
            {i}
          </label>
        </div>
      );
    }

    return (
      <div className={`number-selector ${styleList}`}>
        <span className='number-selector__title'>{title}</span>
        {numbers}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/number-selector/NumberSelector.js